/**
 * Tooling 模块枚举定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端Model常量后重新生成
 * 
 * @generated 2025-11-01T18:25:57.306727Z
 * @generator api:export-types v1.0.0
 */

/**
 * Fixture状态
 */
export enum FixtureSTATUS {
  NORMAL = 1,
  IN_USE = 2,
  NEED_MAINTENANCE = 3,
  SCRAPPED = 4,
}

/**
 * Gauge状态
 */
export enum GaugeSTATUS {
  NORMAL = 1,
  IN_USE = 2,
  NEED_CALIBRATION = 3,
  EXPIRED = 4,
  DISABLED = 5,
}

/**
 * GaugeCalibrationLog类型
 */
export enum GaugeCalibrationLogTYPE {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

/**
 * GaugeCalibrationLogRESULT
 */
export enum GaugeCalibrationLogRESULT {
  QUALIFIED = 'QUALIFIED',
  UNQUALIFIED = 'UNQUALIFIED',
}

/**
 * Mold状态
 */
export enum MoldSTATUS {
  NORMAL = 1,
  IN_USE = 2,
  NEED_MAINTENANCE = 3,
  SCRAPPED = 4,
}

/**
 * Tool状态
 */
export enum ToolSTATUS {
  NORMAL = 1,
  IN_USE = 2,
  NEED_REPLACE = 3,
  SCRAPPED = 4,
}

/**
 * ToolLIFETIME
 */
export enum ToolLIFETIME {
  UNIT_COUNT = 'COUNT',
  UNIT_HOUR = 'HOUR',
}

